import React from 'react';
import { useVideoPlayer } from './use-video-player';
export default function UiVideoPlayer({ model }) {
    const { videoId, videoProvider, title } = model.content;
    const { embed } = useVideoPlayer(videoId, videoProvider, title);
    const hasEmbed = embed !== null;
    return React.createElement("div", { "data-testid": "ui-video-player" }, hasEmbed && embed);
}
//# sourceMappingURL=UiVideoPlayer.js.map